module.exports = __webpack_public_path__ + "img/navigation-left.db5c88b8.svg";